import { push, replace } from 'connected-react-router';
import { stringifyUrl } from 'query-string';
import { Dispatch } from 'redux';
import { StandardQueryParams } from '../../global/types';
import { CUSTOMERS_URL } from '../../global/urls';
import { defaultSortOrder } from './constants';

type QueryParams = StandardQueryParams;

export const getCustomersUrl = (params: QueryParams): string => {
  const query: QueryParams = {};
  if (params.search) {
    query.search = params.search;
  }
  if (params.sort && params.sort !== defaultSortOrder) {
    query.sort = params.sort;
  }
  if (params.start) {
    query.start = params.start;
  }
  return stringifyUrl({ url: CUSTOMERS_URL, query });
};

export const replaceCustomersUrl = (dispatch: Dispatch, params: QueryParams): void => {
  const url = getCustomersUrl(params);
  dispatch(replace(url, { keepState: true }));
};

export const pushCustomersUrl = (
  dispatch: Dispatch,
  params: QueryParams,
  keepState = false
): void => {
  const url = getCustomersUrl(params);
  dispatch(push(url, { keepState }));
};
